import { useEffect, useRef } from "react";
import { registerGraphAccess } from "../../../integrations/tools/outlook/graph-bridge";
import { useAuthState } from "../../auth/AuthStateProvider";

/**
 * Renders nothing — it exists to give the non-React Outlook handlers a live
 * Graph token, the same way ChatConfirmDialog gives them a confirm dialog.
 *
 * Needed by the CM-01 Graph booking fallback (`calendar.open`): the handler map
 * runs outside the React tree, so it cannot read `useAuthState` itself.
 *
 * The token is read through a ref inside the provider closure rather than
 * captured in it, so a token refreshed mid-session is picked up without
 * re-registering (and without a handler holding a stale bearer).
 */
export function GraphAccessBridge(): null {
  const { graphToken, refreshGraphToken } = useAuthState();
  const tokenRef = useRef(graphToken);
  tokenRef.current = graphToken;

  useEffect(() => {
    return registerGraphAccess(() => ({
      token: tokenRef.current,
      refresh: () => refreshGraphToken(),
    }));
  }, [refreshGraphToken]);

  return null;
}
